<template>
  <a-modal
    :title="id? '编辑收货地址':'新增收货地址'"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    ok-text="保存"
    @ok="handleOk"
    @cancel="handleCancel"
    :bodyStyle="{'max-height': '500px', 'overflow': 'auto'}"
  >
    <a-form-model
      ref="form"
      :rules="rules"
      :model="formData"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="姓名" prop="receiver">
        <a-input v-model="formData.receiver" allowClear />
      </a-form-model-item>
      <a-form-model-item label="电话" prop="phone">
        <a-input v-model="formData.phone" :maxLength="11" allowClear />
      </a-form-model-item>
      <a-form-model-item label="收货地址" prop="address">
        <a-input v-model="formData.address" allowClear />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { postEditAddress, postAddAddress, getAddressDetail } from '@/api/print'
const defaultFormData = {
  receiver: '',
  phone: '',
  address: ''
}
export default {
  data() {
    return {
      id: 0,
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      formData: Object.assign({}, defaultFormData),
      rules: {
        receiver: [{ required: true, message: '收货人必填', trigger: 'blur' }],
        phone: [{ required: true, message: '手机号码必填', trigger: 'blur' }],
        address: [{ required: true, message: '收货地址必填', trigger: 'blur' }]
      }
    }
  },
  methods: {
    showModal(id) {
      this.visible = true
      this.id = id
      if (id) {
        // 编辑
        this.getDetail()
      } else {
        // 新增
        this.formData = Object.assign({}, defaultFormData)
      }
    },
    handleOk(e) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.id) {
            // 编辑
            this.postEdit()
          } else {
            // 新增
            this.postAdd()
          }
        } else {
          this.$message.error('还有字段未填写，请检查！')
          return false
        }
      })
    },
    handleCancel(e) {
      this.$refs.form.resetFields()
      this.visible = false
    },
    // 编辑
    postEdit() {
      this.confirmLoading = true
      postEditAddress(this.formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.handleCancel()
            this.$emit('ok')
          }
        })
        .catch((e) => {
          this.$message.error('保存失败')
        })
        .finally(() => { this.confirmLoading = false })
    },
    // 新增
    postAdd() {
      this.confirmLoading = true
      postAddAddress(this.formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.handleCancel()
            this.$emit('ok')
          }
        })
        .catch((e) => {
          this.$message.error('保存失败')
        })
        .finally(() => { this.confirmLoading = false })
    },
    // 详情
    getDetail() {
      getAddressDetail({
        address_id: this.id
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.formData = {
              address_id: data.address_id,
              receiver: data.receiver,
              phone: data.phone,
              address: data.address
            }
          }
        })
        .catch((e) => {
          this.$message.error('获取详情失败')
        })
    }
  }
}
</script>
